import React, { useEffect, useState } from 'react';
import './Censor.scss'

interface TextCensorProps{
    text: string;
    lines?: number;
}

export function TextCensor(props: TextCensorProps){
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if(props.text != null){
            setIsLoading(false);
        }
    }, [props.text]);



    if(isLoading){
        return(<span className={"censor"}>Loading</span>);
    }

    return(<span>{props.text}</span>)
}
